// =============================================================================
// Phase - reine Frontend-Rechnung
// =============================================================================
//
// Welche Phase gerade laeuft, steht NICHT in Directus. Dort steht nur, welche
// Monate zu welcher Phase gehoeren - das ist Inhalt. Welcher Monat heute ist
// und was daraus folgt, ist Logik und gehoert hierher.
// =============================================================================

import type { Phase } from '../directus/typen';

/**
 * Die Phase, in der das angegebene Datum liegt.
 *
 * Gibt es fuer den Monat keine Phase, liefert die Funktion null statt
 * ersatzweise die erste Phase. Der Prototyp hat an dieser Stelle auf PHASES[0]
 * zurueckgegriffen; das versteckt eine Luecke in der Monatszuordnung, die
 * Henner in Directus schliessen sollte, statt sie zu zeigen.
 */
export function phaseAm(datum: Date, phasen: Phase[]): Phase | null {
  const monat = datum.getMonth() + 1;
  return phasen.find((p) => p.monate.includes(monat)) ?? null;
}

/** Prueft, ob die Monate 1-12 lueckenlos und ueberschneidungsfrei verteilt
 *  sind. Ergebnis ist ein Hinweis fuer die Konsole, keine Fehlermeldung fuer
 *  Lehrkraefte - die koennen daran nichts aendern. */
export function monatsLuecken(phasen: Phase[]): number[] {
  const belegt = new Set<number>();
  for (const p of phasen) for (const m of p.monate) belegt.add(m);

  const fehlend: number[] = [];
  for (let m = 1; m <= 12; m++) if (!belegt.has(m)) fehlend.push(m);
  return fehlend;
}
